import React from 'react';
import AvailableTutorials from './AvailableTutorials';
import TutorialListItem from './TutorialListItem';
import * as styles from './TutorialListModal.module.scss';
import TutorialModal from './TutorialModal';
import Button from '../../components/Button';
import list from '../../images/tutorials/list.png';

interface TutorialListModalProps {
  onDismiss: () => void;
}

const TutorialListModal = ({ onDismiss }: TutorialListModalProps) => (
  <TutorialModal
    imageUrl={list}
    title="Getting started with Slab"
    message={
      <>
        <div className={styles.description}>
          Get acquainted with Slab by learning how our core concepts work:
        </div>
        <AvailableTutorials>
          {(tutorials) =>
            tutorials.map(({ displayName, name, icon, link }) => (
              <TutorialListItem
                key={name}
                icon={icon}
                name={name}
                to={link}
                onClick={() => {
                  onDismiss();
                }}
              >
                {displayName}
              </TutorialListItem>
            ))
          }
        </AvailableTutorials>
      </>
    }
    additionalControls={
      <Button variant="muted" onClick={onDismiss}>
        No, thanks
      </Button>
    }
  />
);

export default TutorialListModal;
